import React from 'react';
import { SENSORS } from '../../config';
import styles from './SystemDetails.module.css';
import SensorsGraphWithOptions from './SensorsGraphWithOptions';
import { findHighestAndLowestReadingsFromSensor } from '../../utils/sensorHelpers';
import { useLastMetrics } from '../../hooks/useLastMetrics';
import { useTranslation } from 'react-i18next';

function ModuleCellGraphCard({ systemId, barHeight }) {
  const { lastMetrics } = useLastMetrics(systemId);
  const { t } = useTranslation();

  let sensors = [SENSORS.Voltage, SENSORS.InternalResistance];
  sensors = sensors.map((sensor) => {
    const { highest, lowest } = findHighestAndLowestReadingsFromSensor(
      5,
      lastMetrics,
      sensor
    );
    const sensorIds = [];
    [highest, lowest].forEach((array) => {
      sensorIds.push.apply(
        sensorIds,
        array.map((reading) => reading.deviceSensorId)
      );
    });
    return { ...sensor, ids: sensorIds };
  });

  return (
    <div className={styles.moduleCellGraphCard}>
      <SensorsGraphWithOptions
        showDots={false}
        systemId={systemId}
        sensors={sensors}
        height={barHeight}
        title={t('fiveLargestAndSmallestOverTime')}
      />
    </div>
  );
}

export default ModuleCellGraphCard;
